import React, { useEffect, useState } from "react";
import { Link } from 'react-router-dom';
import axios from 'axios';
import { toast } from 'react-toastify';
import CryptoJS from 'crypto-js';
import uniqid from "uniqid";
import { useSelector } from "react-redux";
import swal from 'sweetalert';
import { Button, Form, Col, Row, Modal } from 'react-bootstrap';
import dateFormat, { masks } from "dateformat";
import moment from 'moment';
import { DataTable } from 'primereact/datatable';
import { Paginator } from 'primereact/paginator';
import { Column } from 'primereact/column';
import { IconField } from 'primereact/iconfield';
import { InputIcon } from 'primereact/inputicon';
import { InputText } from 'primereact/inputtext';
import 'primereact/resources/primereact.min.css';
import 'primereact/resources/themes/fluent-light/theme.css';
import ModalImage from "react-modal-image";
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faInr, faCircleCheck, faCircleXmark } from '@fortawesome/free-solid-svg-icons';
import 'react-date-picker/dist/DatePicker.css';
import 'react-calendar/dist/Calendar.css';
const today = new Date().toISOString().split('T')[0];

function AddMoney() {
  const [currentDate, setCurrentDate] = useState('');
  const [query, setQuery] = useState("");
  const [suggestions, setSuggestions] = useState(false);
  const [userId, setUserId] = useState("");
  const [recordData, setRecordData] = useState(false);
  const [pageData, setPageData] = useState(false);
  const [loading, setLoading] = useState(false);
  const currentUser = useSelector((state) => state.data);
  const [hash, setHash] = useState('');
  const [payuData, setPayuData] = useState({
    key: "s7VM7k3h",
    productinfo: "xxx",
    udf5: "BOLT_KIT_NODE_JS",
    salt: "VuCZddMYIp"
  });
  const [errors, setErrors] = useState(false);
  const [data, setData] = useState(false);
  const [base64, setBase64] = useState('');
  const [showModal, setShowModal] = useState(false);
  const [rejectModal, setRejectModal] = useState(false);
  const [rejectId, setRejectId] = useState(false);
  const [amount, setAmount] = useState(0);
  const [txId, setTxId] = useState(false);
  const [totalAmount, setTotalAmount] = useState(0);
  const [depositType, setDepositType] = useState('');
  const [moneyFor, setMoneyFor] = useState("remitance");
  const [searchFor, setSearchFor] = useState("remitance");
  const [globalFilter, setGlobalFilter] = useState(null);
  const header = (
    <div className="flex flex-wrap gap-2 align-items-center justify-content-between">
      <IconField iconPosition="right">
        <InputIcon className="pi pi-search" />
        <InputText type="search" onInput={(e) => setGlobalFilter(e.target.value)} placeholder="Search..." />
      </IconField>
    </div>
  );
  const handleClose = () => {
    setShowModal(false);
    setRejectModal(false);
  };
  const handleShow = () => setShowModal(true);

  const addAmount = (value) => {
    setAmount(amount + value);
    fetchRechargeData(amount + value);
  };

  const getAmount = (e) => {
    setAmount(e.target.value);
    fetchRechargeData(e.target.value);
  };

  const fetchRechargeData = (amount) => {
    setTotalAmount(parseInt(amount) + parseFloat(amount * 2.36 / 100));
  };

  const getMoneyFor = (e) => {
    setMoneyFor(e.target.value);
    setErrors(false);
  };

  const handleSubmit = async (e) => {
    e.preventDefault();
    const form = e.target;
    let jsonData = {};
    let errorData = {};
    Array.from(form.elements).forEach((item) => {
      if (item.name) {
        if (item.value == "" && item.getAttribute("requiredField")) {
          errorData[item.name] = [addSpaceBetweenCases(item.name)] + " is required";
        }
        jsonData[item.name] = item.value;
      }
    });
    if (amount == 0) {
      errorData["amount"] = "Amount should not be 0";
    }
    if (Object.entries(errorData).length > 0) {
      setErrors(errorData);
    }
    else {
      let txnid = uniqid();
      setTxId(txnid);
      const { amount, paymentMode, bank_name, description, utr_number, cheque_no, deposit_date, total_charge, total_amount } = e.target;
      let arrPaymentMode = ["Bank deposit", "Office Cash", "Cheque", "Paid online"];
      let data = {
        amount: amount?.value,
        user_id: currentUser?._id,
        paymentMode: paymentMode?.value,
        payment_mode: paymentMode?.value,
        bank_name: bank_name?.value,
        description: description?.value,
        utr_number: arrPaymentMode.includes(paymentMode.value) ? new Date().toLocaleString() + "" : utr_number?.value,
        cheque_no: cheque_no?.value,
        photo: base64,
        deposit_date: deposit_date ? deposit_date.value : dateFormat(new Date(), "yyyy-mm-dd"),
        total_charge: total_charge?.value,
        total_amount: total_amount?.value,
      };
      try {
        if (moneyFor == "remitance") {
          var response = await axios.post('/remit-wallet/add/money', data);
          const { status, message } = response.data;
          if (status) {
            swal("Success", "Request sent successfully!", "success");
            setShowModal(false);
          }
        }
        else {
          var response = await axios.post('/wallet-request/web/add', data);
          // let data = {
          //   firstname: currentUser?.name,
          //   amount: total_amount?.value,
          //   baseAmount: amount?.value,
          //   txnid,
          //   phone: currentUser?.mobile,
          //   email: currentUser?.email
          // };
          // var response = await axios.post('payment/initialized/addmoney', data);
          const { status, message } = response.data;
          if (status) {
            swal("Success", "Request sent successfully!", "success");
            setShowModal(false);
            if (paymentMode.value == "Paid online") {
              setTimeout(function () {
                document.querySelector("#payuForm").submit();
              }, 2000);
            }
          }
        }
      } catch (error) {
        if (error?.response?.data?.message) {
          toast(error.response.data.message);
        }
      }
    }
  };
  const handleReasionSubmit = async (e) => {
    e.preventDefault();
    const { rejectReasion } = e.target;
    try {
      let url = (searchFor == "recharge") ? "/wallet-request/decline" : "/remit-wallet/request/decline";
      var response = await axios.post(url, { id: rejectId, message: rejectReasion.value, reason: rejectReasion.value });
      const { status, message } = response.data;
      if (status) {
        document.querySelector(".search-btn").click();
        handleClose();
        swal("Success", "Request decline successfully!", "success");
      }
    }
    catch (error) {
      if (error?.response?.data?.message) {
        toast(error.response.data.message);
      }
    }
  };
  const handleFileChange = (e) => {
    const file = e.target.files[0];
    if (file) {
      const reader = new FileReader();
      reader.onloadend = () => {
        const base64String = reader.result;
        setBase64(base64String);
      };
      reader.readAsDataURL(file);
    }
  };

  const fetchData = async (event) => {
    let reqData = {
      first: event.first,
      rows: event.rows,
      user_id: pageData.user_id,
      payment_mode: pageData.payment_mode,
      start_date: pageData.start_date,
      end_date: pageData.end_date,
      utr_number: pageData.utr_number,
      bank_name: pageData.bank_name,
      status: pageData.status,
      searchFor: pageData.searchFor
    };
    getData(reqData);
  };

  const handleSearch = async (e) => {
    e.preventDefault();
    const { searchFor, payment_mode, start_date, end_date, utr_number, bank_name, status } = e.target;
    let reqData = {
      user_id: userId,
      payment_mode: payment_mode?.value,
      start_date: start_date.value,
      end_date: end_date.value,
      utr_number: utr_number?.value,
      bank_name: bank_name?.value,
      status: (searchFor && searchFor.value == "remitance") ? status.value : (status.value == "pending") ? 1 : (status.value == "approved") ? 2 : (status.value == "rejected") ? 3 : "",
      searchFor: searchFor.value
    };
    getData(reqData);
  };

  const getData = async (requestData) => {
    try {
      setLoading(true);
      //let url = (searchFor && searchFor.value == "remitance") ? '/remit-wallet/request/all/filter' : '/reports/wallet/requests/all';
      let url = (requestData.searchFor == "remitance") ? '/history/addMoneyRemitanceHistory' : '/history/addMoneyRechargeHistory';
      const response = await axios.post(url, requestData);
      const { status, data, records, body, first, rows, totalRecords } = response.data;
      if (status) {
        setData(data);
        setRecordData(records);
        setPageData({ ...body, first, rows, totalRecords });
        setLoading(false);
      }
    } catch (error) {
      if (error?.response?.data?.message) {
        toast(error.response.data.message);
      }
    }
  };

  const ActionResponse = async (e, id, r_status) => {
    e.preventDefault();
    if (r_status == 2) {
      const willApprove = await swal({
        title: "Are you sure?",
        text: "Are you sure that you want to approve this money?",
        icon: "warning",
        dangerMode: true,
      });
      if (willApprove) {
        try {
          let url = (searchFor == "recharge") ? "/wallet-request/approve" : "/remit-wallet/request/approve";
          const response = await axios.post(url, { id, approved_by: currentUser?._id });
          const { status, message } = response.data;
          if (status) {
            document.querySelector(".search-btn").click();
            swal("Success", "Request approved successfully!", "success");
          }
        }
        catch (error) {
          if (error?.response?.data?.message) {
            toast(error.response.data.message);
          }
        }
      }
    }
    else {
      setRejectId(id);
      setRejectModal(true);
    }
  };
  const getHash = () => {
    const hashString = `${payuData.key}|${txId}|${totalAmount}|${payuData.productinfo}|${currentUser?.name}|${currentUser?.email}|||||${payuData.udf5}||||||${payuData.salt}`;
    setHash(CryptoJS.SHA512(hashString).toString(CryptoJS.enc.Hex));
  };
  useEffect(() => {
    getHash();
  }, [totalAmount, currentUser, txId]);
  function addSpaceBetweenCases(str) {
    return capitalizeWords(str.replace(/([a-z])([A-Z])/g, '$1 $2')).replaceAll("_", " ");
  }

  function capitalizeWords(string) {
    return string.split(' ').map(word =>
      word.charAt(0).toUpperCase() + word.slice(1)
    ).join(' ')
  }
  const deleteError = (e) => {
    const errorKey = e.target.name;
    if (errorKey) {
      const updatedErrors = { ...errors };
      delete updatedErrors[errorKey];
      setErrors(updatedErrors);
    }
  };
  useEffect(() => {
    const today = new Date().toISOString().split('T')[0];
    setCurrentDate(today);
  }, []);
  useEffect(() => {
    if (query.length < 2) {
      setSuggestions(false);
      setUserId("");
      return;
    }
    axios.get(`/users/search?q=${encodeURIComponent(query)}`).then((res) => {
      setSuggestions(res.data.users); // Adjust to your API response
    }).catch(() => {
      setSuggestions(false);
    });
  }, [query]);
  return (
    <div class="content-wrapper">
      <div class="row">
        <div class="col-lg-12 grid-margin stretch-card">
          <div class="card">
            <div class="card-body">
              <h4 class="card-title">
                Search
                {/* Button that triggers the modal */}
                <Button className="float-right" variant="primary" onClick={handleShow}>
                  Add
                </Button>
              </h4>
              {/* <p class="card-description">
                Add class <code>.table-hover</code>
              </p> */}
              <form className="searchForm" onSubmit={handleSearch}>
                <div class="row">
                  {
                    currentUser && currentUser.user_type == "admin" && (
                      <div class="col-lg-3 col-md-3">
                        <label for="user_id">Users</label>
                        {/* <select class="form-control" name="user_id">
                          <option value="">--Select--</option>
                          {
                            users && users.map(user => (
                              <option value={user._id}>{user.name}</option>
                            ))
                          }
                        </select> */}
                        <input
                          type="text"
                          class="form-control"
                          value={query}
                          onChange={(e) => setQuery(e.target.value)}
                          placeholder="Type to search..."
                        />

                        {suggestions && suggestions.length > 0 && (
                          <ul
                            style={{
                              border: "1px solid #ccc",
                              marginTop: 0,
                              paddingLeft: 0,
                              listStyleType: "none",
                              maxHeight: 150,
                              overflowY: "auto",
                              cursor: "pointer",
                            }}
                          >
                            {suggestions.map((item, idx) => (
                              <li
                                key={idx}
                                style={{ padding: "8px", borderBottom: "1px solid #eee" }}
                                onClick={() => {
                                  setQuery(item.name + "(" + item.mobile + ")"); // Adjust as per your data structure
                                  setUserId(item._id);
                                  setSuggestions(false);
                                }}
                              >
                                {item.name + "(" + item.mobile + ")"}
                              </li>
                            ))}
                          </ul>
                        )}
                      </div>
                    )
                  }
                  <div class="col-lg-3 col-md-3">
                    <label for="searchFor">Search For</label>
                    <select class="form-control" name="searchFor" onChange={(e) => setSearchFor(e.target.value)} required>
                      <option value="remitance">REMITANCE</option>
                      <option value="recharge">RECHARGE</option>
                    </select>
                  </div>
                  {
                    searchFor == "recharge" && (
                      <>
                        <div class="col-lg-3 col-md-3">
                          <label for="payment_mode">Payment Mode</label>
                          <select class="form-control" name="payment_mode">
                            <option value="">--Select--</option>
                            <option value="Paid online">Paid online</option>
                            <option value="manually">Manually</option>
                          </select>
                        </div>
                      </>
                    )
                  }
                  <div class="col-lg-3 col-md-3">
                    <label for="start_date">From Date</label>
                    <input class="form-control" type="date" name="start_date" value={currentDate} max={today} onChange={(e) => setCurrentDate(e.target.value)} />
                  </div>
                  <div class="col-lg-3 col-md-3">
                    <label for="end_date">To Date</label>
                    <input class="form-control" type="date" name="end_date" max={today} />
                  </div>
                  <div class="col-lg-3 col-md-3">
                    <label for="status">Status</label>
                    <select class="form-control" name="status">
                      <option value="">--Select--</option>
                      <option value="pending">Pending</option>
                      <option value="approved">Approved</option>
                      <option value="rejected">Rejected</option>
                    </select>
                  </div>
                  {
                    searchFor == "remitance" && (
                      <>
                        <div class="col-lg-3 col-md-3">
                          <label for="utr_number">Search by amount / UTR number / NEFT</label>
                          <input class="form-control" type="text" name="utr_number" placeholder="Enter details" />
                        </div>
                        <div class="col-lg-3 col-md-3">
                          <label for="bank_name">Bank Name</label>
                          <select class="form-control" name="bank_name">
                            <option value="">--Select--</option>
                            <option value="5423">HDFC Bank:5423</option>
                            <option value="8621">HDFC Bank:8621</option>
                            <option value="0526">IDFC Bank:0526</option>
                            <option value="9378">IDFC Bank:9378 (Only CASH-₹5 Lakh/Day)</option>
                            <option value="1407">Canara Bank:1407</option>
                            <option value="PNB">PNB BANK:UPI</option>
                            <option value="Payumony">Online Payment</option>
                            <option value="Cash">Only Office Cash</option>
                          </select>
                        </div>
                      </>
                    )
                  }
                  <div class="col-lg-3 col-md-3">
                    <input type="submit" className="search-btn btn btn-primary" value="Search" />
                  </div>
                </div>
              </form>
            </div>
          </div>
        </div>
        <div class="col-lg-12 grid-margin stretch-card">
          <div class="card">
            <div class="card-body">
              {
                (data && searchFor) && (
                  <>
                    <h4 class="card-title">Search Money</h4>
                    <div className="row">
                      <div class="rechargeOp col-lg-2 col-md-2">
                        <label><strong>Total Pending</strong></label>
                        <div>₹ {(recordData?.totalPending).toFixed(2)}</div>
                      </div>
                      <div class="rechargeOp col-lg-2 col-md-2">
                        <label><strong>Total Approved</strong></label>
                        <div>₹ {(recordData?.totalApproved).toFixed(2)}</div>
                      </div>
                      <div class="rechargeOp col-lg-2 col-md-2">
                        <label><strong>Total Rejected</strong></label>
                        <div>₹ {(recordData?.totalRejected).toFixed(2)}</div>
                      </div>
                      <div class="rechargeOp col-lg-2 col-md-2">
                        <label><strong>Total Service Charge</strong></label>
                        <div>₹ {(recordData?.totalServiceCharge).toFixed(2)}</div>
                      </div>
                      <div class="rechargeOp col-lg-2 col-md-2">
                        <label><strong>Total GST Charge</strong></label>
                        <div>₹ {(recordData?.totalGstCharge).toFixed(2)}</div>
                      </div>
                    </div>
                    {
                      searchFor == "recharge" && (
                        <>
                          <DataTable
                            value={data}
                            size="small"
                            globalFilter={globalFilter}
                            header={header}
                            className="custom-table" // Add custom class here
                            loading={loading}
                          >
                            <Column
                              field="index"
                              header="#"
                              sortable
                              body={(rowData, { rowIndex }) => <span data-label="#">{pageData?.first + rowIndex + 1}</span>}
                            />
                            <Column
                              field="deposit_date"
                              header="Date"
                              sortable
                              body={(rowData) => <span data-label="Date">{moment(rowData.deposit_date).format('MMM-DD-YYYY')}<br />{moment(rowData.created_at).format('hh:mm:ss A')}</span>}
                            />
                            <Column
                              field="user_id"
                              header="User(mobile)"
                              sortable
                              body={(rowData) => <span data-label="User">{rowData?.user_id?.name}<br />({rowData?.user_id?.mobile})</span>}
                            />
                            <Column
                              field="amount"
                              header="Amount"
                              sortable
                              body={(rowData) => <span data-label="Amount">{rowData.amount}</span>}
                            />
                            <Column
                              field="total_charge"
                              header="TotalCharge"
                              sortable
                              body={(rowData) => (
                                <span data-label="TotalCharge">
                                  {
                                    // rowData.total_charge
                                    rowData.payment_mode == "Paid online" ? (parseFloat(rowData.amount) * 2.36 / 100) : 0
                                  }
                                </span>
                              )}
                            />
                            <Column
                              field="total_amount"
                              header="TotalAmount"
                              sortable
                              body={(rowData) => (
                                <span data-label="TotalAmount">
                                  {
                                    // rowData?.total_amount
                                    parseFloat(rowData.amount) + (rowData.payment_mode == "Paid online" ? (parseFloat(rowData.amount) * 2.36 / 100) : 0)
                                  }
                                </span>
                              )}
                            />
                            <Column
                              field="description"
                              header="Description"
                              sortable
                              body={(rowData) => <span data-label="Description">{rowData?.description}</span>}
                            />
                            <Column
                              field="payment_mode"
                              header="PaidVia"
                              sortable
                              body={(rowData) => <span data-label="PaidVia">{rowData.payment_mode}</span>}
                            />
                            <Column
                              field="image"
                              header="Image"
                              sortable
                              body={(rowData) => <span data-label="Image"><ModalImage small={rowData.filepath} large={rowData.filepath} alt={rowData?.user_id?.name} /></span>}
                            />
                            <Column
                              field="bank_name"
                              header="Bank"
                              sortable
                              body={(rowData) => <span data-label="Bank">{rowData.bank_name}</span>}
                            />
                            <Column
                              field="utr_number"
                              header="UtrNo"
                              sortable
                              body={(rowData) => <span data-label="UtrNo">{rowData.utr_number}</span>}
                            />
                            <Column
                              field="status"
                              header="Status"
                              sortable
                              body={(rowData) => <span data-label="Status">{rowData.image ? rowData.status : (rowData.status == 1) ? "Pending" : (rowData.status == "2") ? "Approved" : "Rejected"}</span>}
                            />
                            <Column
                              field="message"
                              header="Message"
                              sortable
                              body={(rowData) => <span data-label="Message">{rowData.message}</span>}
                            />
                            <Column
                              field="action"
                              header="Action"
                              sortable
                              body={(rowData) => (
                                <span data-label="Action">
                                  {currentUser.user_type == "admin" && rowData.status == "1" && (
                                    <>
                                      <Link onClick={(e) => ActionResponse(e, rowData._id, 2)}><FontAwesomeIcon icon={faCircleCheck} className="successIcon" title="Approve" /></Link>
                                      <Link onClick={(e) => ActionResponse(e, rowData._id, 3)}><FontAwesomeIcon icon={faCircleXmark} className="errorIcon" title="Reject" /></Link>
                                      {/* <button className="btn btn-primary" onClick={(e) => ActionResponse(e, rowData._id, 2)}>Approve</button>
                                    <button className="btn btn-primary" onClick={(e) => ActionResponse(e, rowData._id, 3)}>Reject</button> */}
                                    </>
                                  )}
                                </span>
                              )}
                            />
                          </DataTable>
                          <div className="card">
                            <Paginator first={pageData && pageData.first} rows={pageData && pageData.rows} totalRecords={pageData && pageData.totalRecords} rowsPerPageOptions={[5, 10, 20, 30, 40, 50, 100, 200, 300, 400, 500, 1000]} onPageChange={fetchData} />
                          </div>
                        </>
                      )
                    }
                    {
                      searchFor == "remitance" && (
                        <>
                          <DataTable
                            value={data}
                            size="small"
                            globalFilter={globalFilter}
                            header={header}
                            className="custom-table" // Add custom class here
                            loading={loading}
                          >
                            <Column
                              field="index"
                              header="#"
                              sortable
                              body={(rowData, { rowIndex }) => <span data-label="#">{pageData?.first + rowIndex + 1}</span>}
                            />
                            <Column
                              field="deposit_date"
                              header="Date"
                              sortable
                              body={(rowData) => <span data-label="Date">{moment(rowData.deposit_date).format('MMM-DD-YYYY')}<br />{moment(rowData.created_at).format('hh:mm:ss A')}</span>}
                            />
                            <Column
                              field="user_id"
                              header="User(mobile)"
                              sortable
                              body={(rowData) => <span data-label="User">{rowData?.user_id?.name}<br />({rowData?.user_id?.mobile})</span>}
                            />
                            <Column
                              field="amount"
                              header="Amount"
                              sortable
                              body={(rowData) => <span data-label="Amount">{rowData.amount}</span>}
                            />
                            <Column
                              field="description"
                              header="Description"
                              sortable
                              body={(rowData) => <span data-label="Description">{rowData?.description}</span>}
                            />
                            <Column
                              field="payment_mode"
                              header="PaidVia"
                              sortable
                              body={(rowData) => <span data-label="PaidVia">{rowData.payment_mode}</span>}
                            />
                            <Column
                              field="image"
                              header="Image"
                              sortable
                              body={(rowData) => <span data-label="Image"><ModalImage small={process.env.REACT_APP_BACKEND_URL + `/` + rowData.image} large={process.env.REACT_APP_BACKEND_URL + `/` + rowData.image} alt={rowData?.user_id?.name} /></span>}
                            />
                            <Column
                              field="bank_name"
                              header="Bank"
                              sortable
                              body={(rowData) => <span data-label="Bank">{rowData.bank_name}</span>}
                            />
                            <Column
                              field="utr_number"
                              header="UtrNo"
                              sortable
                              body={(rowData) => <span data-label="UtrNo">{rowData.utr_number}</span>}
                            />
                            <Column
                              field="status"
                              header="Status"
                              sortable
                              body={(rowData) => <span data-label="Status">{rowData.image ? rowData.status : (rowData.status == 1) ? "Pending" : (rowData.status == "2") ? "Approved" : "Rejected"}</span>}
                            />
                            <Column
                              field="message"
                              header="Message"
                              sortable
                              body={(rowData) => <span data-label="Message">{rowData.message}</span>}
                            />
                            <Column
                              field="action"
                              header="Action"
                              sortable
                              body={(rowData) => (
                                <span data-label="Action">
                                  {currentUser.user_type == "admin" && rowData.status == "pending" && (
                                    <>
                                      <Link onClick={(e) => ActionResponse(e, rowData._id, 2)}><FontAwesomeIcon icon={faCircleCheck} className="successIcon" title="Approve" /></Link>
                                      <Link onClick={(e) => ActionResponse(e, rowData._id, 3)}><FontAwesomeIcon icon={faCircleXmark} className="errorIcon" title="Reject" /></Link>
                                      {/* <button className="btn btn-primary" onClick={(e) => ActionResponse(e, rowData._id, 2)}>Approve</button>
                                    <button className="btn btn-primary" onClick={(e) => ActionResponse(e, rowData._id, 3)}>Reject</button> */}
                                    </>
                                  )}
                                </span>
                              )}
                            />
                          </DataTable>
                          <div className="card">
                            <Paginator first={pageData && pageData.first} rows={pageData && pageData.rows} totalRecords={pageData && pageData.totalRecords} rowsPerPageOptions={[5, 10, 20, 30, 40, 50, 100, 200, 300, 400, 500, 1000]} onPageChange={fetchData} />
                          </div>
                        </>
                      )
                    }
                  </>
                )
              }
            </div>
          </div>
        </div>
      </div>
      {/* Modal component */}
      <Modal show={showModal} onHide={handleClose} centered size={'xl'} backdrop="static">
        <Form onSubmit={handleSubmit}>
          <Modal.Header closeButton>
            <Modal.Title>Add Money</Modal.Title>
          </Modal.Header>
          <Modal.Body>
            <div class="row justify-content-center">
              <div class="col-md-12">
                <div className="row">
                  <p>"कृपया ध्यान दें कि आपने जो पहले अपलोड की गई राशि की स्लिप है, उसे पुनः अपलोड न करें। कृपया इस निर्देश का पालन करें। जिस भुगतान स्लिप को आपने अपलोड Upload किया है, उसे क्रॉस चेक कर लें (×)। एक बार पूरी जानकारी की जांच कर लें। धन्यवाद।"</p>
                  {/* Amount Field */}
                  <div class="col-md-12 text-center">
                    <h4>Who do you wish to add money for?</h4>
                    <div class="form-check form-check-inline">
                      <input class="form-check-input" type="radio" name="addMoneyFor" id="radio1" value="remitance" onClick={getMoneyFor} checked={moneyFor === "remitance"} />
                      <label class="form-check-label" for="radio1">REMITANCE</label>
                    </div>
                    <div class="form-check form-check-inline">
                      <input class="form-check-input" type="radio" name="addMoneyFor" id="radio2" value="recharge" onClick={getMoneyFor} checked={moneyFor === "recharge"} />
                      <label class="form-check-label" for="radio2">RECHARGE</label>
                    </div>
                  </div>
                  <Form.Group className="col-md-12" controlId="formAmount">
                    <Form.Label>Enter Amount</Form.Label>
                    <Form.Control
                      type="number"
                      name="amount"
                      placeholder="Enter amount"
                      value={amount}
                      onChange={getAmount}
                      requiredField="true"
                    />
                  </Form.Group>
                  {
                    (moneyFor == "remitance") ? (
                      <div className="col-md-12 deposit-buttons">
                        <Row>
                          <Col lg={3} md={3}>
                            <div className="bt_boxes">
                              <Button className="btn" onClick={() => addAmount(2000)}>
                                + <FontAwesomeIcon icon={faInr} className="rupees" /> 2000
                              </Button>
                            </div>
                          </Col>
                          <Col lg={3} md={3}>
                            <div className="bt_boxes">
                              <Button className="btn" onClick={() => addAmount(4000)}>
                                + <FontAwesomeIcon icon={faInr} className="rupees" /> 4000
                              </Button>
                            </div>
                          </Col>
                          <Col lg={3} md={3}>
                            <div className="bt_boxes">
                              <Button className="btn" onClick={() => addAmount(8000)}>
                                + <FontAwesomeIcon icon={faInr} className="rupees" /> 8000
                              </Button>
                            </div>
                          </Col>
                          <Col lg={3} md={3}>
                            <div className="bt_boxes">
                              <Button className="btn" onClick={() => addAmount(10000)}>
                                + <FontAwesomeIcon icon={faInr} className="rupees" /> 10000
                              </Button>
                            </div>
                          </Col>
                        </Row>
                        <span className="error">{errors && errors?.amount}</span>
                      </div>
                    ) : (
                      <div className="col-md-12 deposit-buttons">
                        <Row>
                          <Col lg={3} md={3}>
                            <div className="bt_boxes">
                              <Button className="btn" onClick={() => addAmount(200)}>
                                + <FontAwesomeIcon icon={faInr} className="rupees" /> 200
                              </Button>
                            </div>
                          </Col>
                          <Col lg={3} md={3}>
                            <div className="bt_boxes">
                              <Button className="btn" onClick={() => addAmount(400)}>
                                + <FontAwesomeIcon icon={faInr} className="rupees" /> 400
                              </Button>
                            </div>
                          </Col>
                          <Col lg={3} md={3}>
                            <div className="bt_boxes">
                              <Button className="btn" onClick={() => addAmount(800)}>
                                + <FontAwesomeIcon icon={faInr} className="rupees" /> 800
                              </Button>
                            </div>
                          </Col>
                          <Col lg={3} md={3}>
                            <div className="bt_boxes">
                              <Button className="btn" onClick={() => addAmount(1000)}>
                                + <FontAwesomeIcon icon={faInr} className="rupees" /> 1000
                              </Button>
                            </div>
                          </Col>
                        </Row>
                        <span className="error">{errors && errors?.amount}</span>
                      </div>
                    )
                  }
                  {/* Deposit Type (Radio Buttons) */}
                  <Form.Group className="col-md-4">
                    <Form.Label>Deposit Type</Form.Label>
                    <Form.Control
                      as="select"
                      name="paymentMode"
                      onChange={(e) => setDepositType(e.target.value)}
                      requiredField="true"
                    >
                      <option value="">Select Deposit</option>
                      {(['Bank deposit', 'Office Cash', 'UPI', 'Cheque', 'NEFT', 'RTGS', 'Internet Banking', 'IMPS', 'TPT', 'ATM Cash Deposit']).map((type) => (
                        <option value={type}>{type}</option>
                      ))}
                    </Form.Control>
                    <span className="error">{errors && errors?.paymentMode}</span>
                  </Form.Group>
                  {
                    <>
                      <Form.Group className="col-md-4" controlId="formBankName">
                        <Form.Label>Bank Name</Form.Label>
                        <Form.Control
                          as="select"
                          name="bank_name"
                          onChange={deleteError}
                          requiredField="true"
                        >
                          <option value="">--Select--</option>
                          <option value="5423">HDFC Bank:5423</option>
                          <option value="8621">HDFC Bank:8621</option>
                          <option value="0526">IDFC Bank:0526</option>
                          <option value="9378">IDFC Bank:9378 (Only CASH-₹5 Lakh/Day)</option>
                          <option value="1407">Canara Bank:1407</option>
                          <option value="PNB">PNB BANK:UPI</option>
                          <option value="Payumony">Online Payment</option>
                          <option value="Cash">Only Office Cash</option>
                        </Form.Control>
                        <span className="error">{errors && errors?.bank_name}</span>
                      </Form.Group>
                      {/* Description Field */}
                      <Form.Group className="col-md-4" controlId="formDescription">
                        <Form.Label>Description</Form.Label>
                        <Form.Control
                          type="text"
                          name="description"
                          placeholder="Enter description"
                          onChange={deleteError}
                          requiredField="true"
                        />
                        <span className="error">{errors && errors?.description}</span>
                      </Form.Group>
                    </>
                  }
                  {
                    depositType == "UPI" && (
                      <Form.Group className="col-md-4" controlId="formDescription">
                        <Form.Label>UTR Number (12 digits)</Form.Label>
                        <Form.Control
                          type="number"
                          name="utr_number"
                          placeholder="123456789012"
                          onChange={deleteError}
                          requiredField="true"
                        />
                        <span className="error">{errors && errors?.utr_number}</span>
                      </Form.Group>
                    )
                  }
                  {
                    depositType == "Cheque" && (
                      <Form.Group className="col-md-4" controlId="formDescription">
                        <Form.Label>Cheque Number (6 digits)</Form.Label>
                        <Form.Control
                          type="number"
                          name="cheque_no"
                          placeholder="123456"
                          onChange={deleteError}
                          requiredField="true"
                        />
                        <span className="error">{errors && errors?.cheque_no}</span>
                      </Form.Group>
                    )
                  }
                  {
                    depositType == "NEFT" && (
                      <Form.Group className="col-md-4" controlId="formDescription">
                        <Form.Label>NEFT Number (16 digits)</Form.Label>
                        <Form.Control
                          type="text"
                          name="utr_number"
                          placeholder="HDFC012345678910"
                          onChange={deleteError}
                          requiredField="true"
                        />
                        <span className="error">{errors && errors?.utr_number}</span>
                      </Form.Group>
                    )
                  }
                  {
                    depositType == "RTGS" && (
                      <Form.Group className="col-md-4" controlId="formDescription">
                        <Form.Label>RTGS Number (22 digits)</Form.Label>
                        <Form.Control
                          type="text"
                          name="utr_number"
                          placeholder="SBINYYMMDD123456789"
                          onChange={deleteError}
                          requiredField="true"
                        />
                        <span className="error">{errors && errors?.utr_number}</span>
                      </Form.Group>
                    )
                  }
                  {
                    depositType == "Internet Banking" && (
                      <Form.Group className="col-md-4" controlId="formDescription">
                        <Form.Label>Referance Number (7 digits)</Form.Label>
                        <Form.Control
                          type="number"
                          name="utr_number"
                          placeholder="1234567"
                          onChange={deleteError}
                          requiredField="true"
                        />
                        <span className="error">{errors && errors?.utr_number}</span>
                      </Form.Group>
                    )
                  }
                  {
                    depositType == "IMPS" && (
                      <Form.Group className="col-md-4" controlId="formDescription">
                        <Form.Label>IMPS Number (12 digits)</Form.Label>
                        <Form.Control
                          type="number"
                          name="utr_number"
                          placeholder="123456789012"
                          onChange={deleteError}
                          requiredField="true"
                        />
                        <span className="error">{errors && errors?.utr_number}</span>
                      </Form.Group>
                    )
                  }
                  {
                    depositType == "TPT" && (
                      <Form.Group className="col-md-4" controlId="formDescription">
                        <Form.Label>TPT Number (12 digits)</Form.Label>
                        <Form.Control
                          type="number"
                          name="utr_number"
                          placeholder="123456789012"
                          onChange={deleteError}
                          requiredField="true"
                        />
                        <span className="error">{errors && errors?.utr_number}</span>
                      </Form.Group>
                    )
                  }
                  {
                    depositType == "ATM Cash Deposit" && (
                      <Form.Group className="col-md-4" controlId="formDescription">
                        <Form.Label>RRN Number (4 digits)</Form.Label>
                        <Form.Control
                          type="number"
                          name="utr_number"
                          placeholder="1234"
                          onChange={deleteError}
                          requiredField="true"
                        />
                        <span className="error">{errors && errors?.utr_number}</span>
                      </Form.Group>
                    )
                  }
                  {
                    <>
                      {/* File Upload */}
                      <Form.Group className="col-md-4" controlId="formReceipt">
                        <Form.Label>Upload Receipt</Form.Label>
                        <Form.Control
                          type="file"
                          name="photo"
                          accept="image/*"
                          onChange={handleFileChange}
                          requiredField="true"
                        />
                        <span className="error">{errors && errors?.photo}</span>
                      </Form.Group>
                      {/* Deposit Date */}
                      <Form.Group className="col-md-4" controlId="formDepositDate">
                        <Form.Label>Deposit Date</Form.Label>
                        <Form.Control
                          type="date"
                          name="deposit_date"
                          onChange={deleteError}
                          requiredField="true"
                        />
                        <span className="error">{errors && errors?.deposit_date}</span>
                      </Form.Group>
                    </>
                  }
                </div>
              </div>
            </div>
          </Modal.Body>
          <Modal.Footer>
            <Button variant="primary" type="submit">
              {"Submit"}
            </Button>
            <Button variant="secondary" onClick={handleClose} className="ml-2">
              Cancel
            </Button>
          </Modal.Footer>
        </Form>
      </Modal>
      <Modal show={rejectModal} onHide={handleClose} centered size={'xl'} backdrop="static">
        <Form onSubmit={handleReasionSubmit}>
          <Modal.Header closeButton>
            <Modal.Title>Rejact Reasion</Modal.Title>
          </Modal.Header>
          <Modal.Body>
            <div class="row justify-content-center">
              <div class="col-md-12">
                <div className="row">
                  <Form.Group className="col-md-12">
                    <Form.Label>Reasion</Form.Label>
                    <Form.Control
                      as="select"
                      name="rejectReasion"
                      required
                    >
                      <option value="">--Select--</option>
                      {([`Incorrect Details – Provide the correct bank name, UTR number, deposit date, branch name, and depositor's name.
`, `Payment Not Received – The amount has not been credited; verify with your bank.
`, `Already Processed – The transaction is approved or successfully completed.
`, `Select Correct Deposit Bank – Choose the appropriate deposit bank.
`, `Recharge Wallet Approved – Check your wallet balance.
`, `Remittance Wallet Approved – Check your wallet balance.
`, `Select Deposit Mode – Choose UPI, IMPS, NEFT, RTGS, or any other available option.
`, `Deposit Slip Issue – The UTR/reference number is not visible. Please check your bank statement or UPI transaction history and upload a clear slip showing the UTR/IMPS number.`]).map((type) => (
                        <option value={type}>{type}</option>
                      ))}
                    </Form.Control>
                    <span className="error">{errors && errors?.paymentMode}</span>
                  </Form.Group>
                </div>
              </div>
            </div>
          </Modal.Body>
          <Modal.Footer>
            <Button type="submit" variant="primary">
              Reject
            </Button>
          </Modal.Footer>
        </Form>
      </Modal>
      <div>
        <form id="payuForm" name="payuForm" action={process.env.REACT_APP_PAYU_URL} method="POST" target="_blank">
          <input type="hidden" name="key" value={payuData.key} />
          <input type="hidden" name="hash" value={hash} />
          <input type="hidden" name="txnid" value={txId} />
          <input type="hidden" name="amount" value={totalAmount} />
          <input type="hidden" name="productinfo" value={payuData.productinfo} />
          <input type="hidden" name="firstname" value={currentUser?.name} />
          <input type="hidden" name="email" value={currentUser?.email} />
          <input type="hidden" name="udf5" value={payuData.udf5} />
          <input type="hidden" name="phone" value="" />
          <input type="hidden" name="surl" value={process.env.REACT_APP_BACKEND_URL + '/admin/rechargeSuccess'} />
          <input type="hidden" name="furl" value={process.env.REACT_APP_BACKEND_URL + '/admin/rechargeFail'} />
        </form>
      </div>
    </div>
  );
}

export default AddMoney;
